/** Unwrap vue-i18n locale refs / objects to a moment-compatible locale string. */
export function resolveLocaleString (locale) {
  if (!locale) {
    return ''
  }
  if (typeof locale === 'string') {
    return locale.split('-')[0]
  }
  if (typeof locale === 'object' && locale !== null && 'value' in locale) {
    return resolveLocaleString(locale.value)
  }
  return String(locale).split('-')[0]
}
